import { marked } from 'marked'

// Configure marked for security and style
marked.setOptions({
  breaks: true,
  gfm: true,
})

/**
 * Render markdown content to HTML.
 * Handles literal \n strings from database seed data.
 */
export function renderMarkdown(content: string | null | undefined): string {
  if (!content) return ''
  // Fix literal \n strings stored in the database
  const cleaned = content.replace(/\\n/g, '\n')
  return marked.parse(cleaned) as string
}
